import React, { useState, createContext, useContext } from 'react';

const AssistantContext = createContext();

export const useAssistantContext = () => {
    return useContext(AssistantContext);
};

export const Provider = ({ children }) => {
    const [assistantOpen, setAssistantOpen] = useState(false);
    const [text, setText] = useState('How can I help you today?');
    
    const providerValues = {
        assistantOpen,
        text,
        // Don't really need to export these?
        setAssistantOpen,
        setText,
    };

    return (
        <AssistantContext.Provider value={providerValues}>
            {children}
        </AssistantContext.Provider>
    );
};
